const { Storage, globalStorage: storage } = window.o_global ?? {};
export {
  Storage,
  storage
};
/*                                */
